export default __webpack_public_path__ + "static/media/fb_white.8dcf865a.svg";